<script setup lang="ts">
const IndustriesContent = defineAsyncComponent(() => import('~/components/molecules/IndustriesContent.vue'));
</script>

<template>
  <IndustriesContent />
</template>
